import { styled } from 'styled-components';

export const ModalBody = styled.div`
  margin-top: 1rem;
  word-break: break-word;
  overflow-y: auto;
  text-align: left;

  // Styles for Firefox
  scrollbar-color: #a7a8a9 ${(props) => props.theme.colors.oxfordBlue[10]};
  scrollbar-width: thin;

  @-moz-document url-prefix() {
    padding: 0 1rem;
  }

  // Styles for other browsers
  &::-webkit-scrollbar {
    width: 1.5625rem;
  }

  &::-webkit-scrollbar-thumb {
    background: #a7a8a9;
    border-radius: 0.8rem;
    border: 0.5rem solid rgba(0, 0, 0, 0);
    background-clip: padding-box;
  }

  &::-webkit-scrollbar-track {
    width: 0.5625rem;
    background: ${(props) => props.theme.colors.slateGray[10]};
    border-radius: 0.8rem;
    border: 0.5rem solid rgba(0, 0, 0, 0);
    background-clip: padding-box;
  }
`;
